import Head from 'next/head';
import { BackToTopCode } from '@/components/codeHighlights/BackToTopCode';

const Page = () => {
  return (
    <>
      <Head>
        <title>Back-To-Top</title>
      </Head>

      <h1>Back-To-Top</h1>
      <p className="lead">
        Der Back-To-Top Button ist eine Komponente, die es dem Benutzer
        ermöglicht schnell an den Anfang der Seite zu gelangen. Der Button wird
        automatisch unten rechts angezeigt, sobald der Benutzer eine bestimmte
        Scrollposition erreicht hat. Diese Komponente ist vor allem auf mobilen
        Endgeräten sehr hilfreich.
      </p>
      <BackToTopCode />
    </>
  );
};

export default Page;
